const imsrconfig = {
  stage: "prod",
  endpoint: "https://api.pescle.com/",
  movie: "https://d3n1qedq4trfz3.cloudfront.net/",
  imageUpload: "https://fileapi.pescle.com/image_upload",
  apikey: "deoA9uP9j65Y7tvIo1oxp4hLPv27xoPF71muILA6",
  ga4Id: "G-JDG3FY82JM",
};

export default imsrconfig;
